<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.01.04</b> - 9 new caverns mobs! Plus balance & AI fixes...</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Get ready to face these new mobs in the Caverns:
        <ul>
          <li>- Ectoplasm</li>
          <li>- Fire Drake</li>
          <li>- Flying Jelly</li>
          <li>- Ghost</li>
          <li>- Goo</li>
          <li>- Lich</li>
          <li>- Phantasm</li>
          <li>- Voidwalker</li>
          <li>- Wraith</li>
        </ul>
      </li>
      <li>
        Balance
        <ul>
          <li>
            - Reduced duration of fears
            <ul>
              <li class="pl-4">
                * Road to Nowhere:
                <code>1 + L*(Le/100 + Pe/150)</code> -->
                <code>1 + L*(Le/150 + Pe/200)</code>
              </li>
              <li class="pl-4">
                * Devil Mask:
                <code>0.5 + L*(Ma/250 + Le/350)</code> -->
                <code>0.5 + L*(Ma/333 + Le/333)</code>
              </li>
            </ul>
          </li>
          <li>
            - Reduced duration of Taunt:
            <code>1 + L*(Wi/200 + Pe/250)</code> -->
            <code>1 + L*(Wi/225 + Pe/275)</code>
          </li>
          <li>
            - Increased duration of summoned Dwarves/Elves/Faeries:
            <code>40 + L*2</code> --> <code>40 + L*5</code>
          </li>
          <li>
            - Increased the AP cost of several abilities:
            <ul>
              <li class="pl-4">* Road to Nowhere: <code>15</code> --> <code>50</code></li>
              <li class="pl-4">
                * Summon Dwarf/Elf/Faerie: <code>10</code> -->
                <code>35</code>
              </li>
              <li class="pl-4">* Psyche Out: <code>10</code> --> <code>35</code></li>
              <li class="pl-4">* Devil Mask: <code>40</code> --> <code>50</code></li>
              <li class="pl-4">* Poppets: <code>10</code> --> <code>35</code></li>
              <li class="pl-4">* Bless: <code>10</code> --> <code>25</code></li>
            </ul>
          </li>
          <li>
            - ONE ability, however, got an AP cost reduction - Stance Dancing:
            <code>70</code> --> <code>50</code>
          </li>
          <li>
            - Increased Summon Option range:
            <code>5</code> --> <code>9</code>
          </li>
          <li>- Reduced the damage of Fire/Thunder/Weepin/Venomous weapon procs,</li>
          <li>
            - Adjusted the gold prices of items in the shop (made sensitive to
            prefixes/suffixes)
          </li>
          <li>- Increased stat bonuses for Trinket type items</li>
        </ul>
      </li>
      <li>
        AI
        <ul>
          <li>
            - Fixed a bug causing ranged units to use AoE attacks when single-target is
            better
          </li>
          <li>- Fixed bugs in the movement AI, esp. for units with Leap/Teleport</li>
          <li>- Fixed a bug causing units to fumigate a lot of nearby allies</li>
          <li>- Tanks will no longer taunt enemies who are feared</li>
        </ul>
      </li>
      <li>Fixed the Suture ability</li>
      <li>
        Fixed several bugs in damage calculations, especially for Armor Spikes. Also made
        poison & bleed damage affected by Affinities
      </li>
      <li>Caverns: play an alert sound when a room is cleared</li>
    </ul>
  </div>
</template>
